/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { NonIdealState } from '@blueprintjs/core';
import React from 'react';
import { FullPageLoader } from 'components/loadingIcon/fullPageLoader';

export const NetworkConfigContext = React.createContext(null);

export function ConfigFetcher({ children }) {
	const {
		data: config,
		loading,
		error,
	} = useAsyncCallback(async () => {
		const url = `${process.env.NODE_ENV === 'production' ? '.' : ''}/react_config.json`;
		const response = await fetch(url, {
			method: 'GET',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
		});
		if (response && response.status >= 200 && response.status < 300) {
			return response.json();
		} else {
			throw new Error('Server responded with invalid status code while fetching react_config.json');
		}
	}, []);

	if (loading) return <FullPageLoader />;

	if (error) {
		return (
			<NonIdealState
				icon={'error'}
				title={'Aw Shucks!'}
				description={"I couldn't get the Front End React configuration."}
			/>
		);
	}

	// Render props for configuartion
	return <NetworkConfigContext.Provider value={config}>{children({ config })}</NetworkConfigContext.Provider>;
}
